const configuredPublicUrl = process.env.PUBLIC_URL || "/";
const publicBaseUrl = new URL(
    configuredPublicUrl.endsWith("/") ? configuredPublicUrl : `${configuredPublicUrl}/`,
    window.location.href,
);

const getPublicAssetUrl = (path: string) => (
    new URL(path.replace(/^\/+/, ""), publicBaseUrl).toString()
);

export default getPublicAssetUrl;
